import SectionHeading from "./SectionHeading";
import CompareSlider from "@/components/feature/CompareSlider";
import { repairCases } from "@/mocks/home";

export default function RepairCases() {
  return (
    <section id="cases" className="w-full bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="Repair Cases"
          title="수리 전후를"
          highlight="직접 비교해 보세요"
          desc="실제 수리한 로직보드와 부품의 전후 상태입니다. 가운데 손잡이를 좌우로 드래그하면 수리 전과 후를 비교할 수 있습니다."
        />

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {repairCases.map((item, index) => (
            <article
              key={item.id}
              className="reveal flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
              style={{ transitionDelay: `${index * 70}ms` }}
            >
              <CompareSlider
                beforeSrc={item.beforeSrc}
                afterSrc={item.afterSrc}
                beforeAlt={`${item.title} 수리 전 상태`}
                afterAlt={`${item.title} 수리 후 상태`}
              />
              <div className="flex flex-1 flex-col p-5">
                <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 font-label text-xs font-bold text-secondary-800">
                  <i className="ri-tools-line"></i>
                  {item.tag}
                </span>
                <h3 className="mt-3.5 font-heading text-lg font-black text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1 font-label text-xs font-bold text-primary-600">{item.device}</p>
                <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="reveal mt-10 flex flex-col items-center justify-between gap-5 rounded-lg border border-background-200 bg-background-100 p-6 md:flex-row md:p-8">
          <div className="flex items-center gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className="ri-gallery-view-2 text-2xl"></i>
            </span>
            <div>
              <p className="font-heading text-lg font-black text-foreground-950">
                수리 사례가 더 궁금하신가요?
              </p>
              <p className="mt-1 font-body text-sm text-foreground-600">
                카카오톡 채널과 블로그에서 실제 수리 사례를 꾸준히 공유하고 있습니다.
              </p>
            </div>
          </div>
          <a
            href="#inquiry"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-label text-base font-bold text-background-50 transition-colors hover:bg-primary-600 md:w-auto"
          >
            <i className="ri-customer-service-2-line text-lg"></i>
            내 기기 수리 문의하기
          </a>
        </div>
      </div>
    </section>
  );
}